var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("table", { attrs: { border: "1", cellspacing: "0" } }, [
        _c("colgroup", [
          _c("col", { staticStyle: { width: "10%" } }),
          _vm._v(" "),
          _c("col", { staticStyle: { width: "12%" } }),
          _vm._v(" "),
          _c("col", { staticStyle: { width: "21%" } }),
          _vm._v(" "),
          _c("col", { staticStyle: { width: "22%" } }),
          _vm._v(" "),
          _c("col", { staticStyle: { width: "15%" } }),
          _vm._v(" "),
          _c("col", { staticStyle: { width: "20%" } }),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", { staticClass: "table-title", attrs: { colspan: "6" } }, [
            _vm._v("个人信息收集清单"),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("信息类型")]),
          _vm._v(" "),
          _c("td", [_vm._v("信息名称")]),
          _vm._v(" "),
          _c("td", [_vm._v("使用目的")]),
          _vm._v(" "),
          _c("td", [_vm._v("收集场景")]),
          _vm._v(" "),
          _c("td", [_vm._v("收集情况")]),
          _vm._v(" "),
          _c("td", [_vm._v("信息内容")]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", { attrs: { rowspan: "6" } }, [_vm._v("用户基本信息")]),
          _vm._v(" "),
          _c("td", [_vm._v("手机号")]),
          _vm._v(" "),
          _c("td", [_vm._v("用于注册创建账号，完善网络身份标识")]),
          _vm._v(" "),
          _c("td", [_vm._v("用户首次注册时主动输入")]),
          _vm._v(" "),
          _c("td", [_vm._v("收集1条")]),
          _vm._v(" "),
          _c("td", [_vm._v("133****1234")]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("电子邮箱")]),
          _vm._v(" "),
          _c("td", [
            _vm._v("1.用于注册创建账号；"),
            _c("br"),
            _vm._v("2.修改已创建账号的密码；"),
            _c("br"),
            _vm._v("3.注销账号时收取验证信息；"),
          ]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "用户首次注册账户时，或使用修改密码、注销账户功能时主动输入"
            ),
          ]),
          _vm._v(" "),
          _c("td", [_vm._v("收集1条")]),
          _vm._v(" "),
          _c("td", [_vm._v("Todo***@163.com")]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("Apple ID")]),
          _vm._v(" "),
          _c("td", [_vm._v("用于创建都都会员账号，完善网络身份标识")]),
          _vm._v(" "),
          _c("td", [
            _vm._v("用户首次登录时主动提供（仅限于用户已授权给苹果）"),
          ]),
          _vm._v(" "),
          _c("td", [_vm._v("收集1条")]),
          _vm._v(" "),
          _c("td", [_vm._v("Appleid23de**********")]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("Google ID")]),
          _vm._v(" "),
          _c("td", [_vm._v("用于创建都都会员账号，完善网络身份标识")]),
          _vm._v(" "),
          _c("td", [
            _vm._v("用户首次登录时主动提供（仅限于用户已授权给谷歌）"),
          ]),
          _vm._v(" "),
          _c("td", [_vm._v("收集1条")]),
          _vm._v(" "),
          _c("td", [_vm._v("googleid23de**********")]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("昵称")]),
          _vm._v(" "),
          _c("td", [_vm._v("用于账号展示")]),
          _vm._v(" "),
          _c("td", [_vm._v("用户编辑信息自主输入")]),
          _vm._v(" "),
          _c("td", [_vm._v("收集1条")]),
          _vm._v(" "),
          _c("td", [_vm._v("都都")]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("出生年月")]),
          _vm._v(" "),
          _c("td", [_vm._v("用于创建使用者学习信息，对所选学习级别提供建议")]),
          _vm._v(" "),
          _c("td", [_vm._v("用户编辑信息自主输入")]),
          _vm._v(" "),
          _c("td", [_vm._v("收集1条")]),
          _vm._v(" "),
          _c("td", [_vm._v("2015-12")]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("设备信息")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "硬件型号、操作系统类型、设备中的国家/地区、设备中的语言设置、设备ID（AndroidID）、IP、IDFA（仅限IOS）、Android ID（仅限安卓）"
            ),
          ]),
          _vm._v(" "),
          _c("td", [_vm._v("用于排查产品使用问题，保障产品的安全和使用体验")]),
          _vm._v(" "),
          _c("td", [_vm._v("使用APP过程中APP收集")]),
          _vm._v(" "),
          _c("td", [_vm._v("收集1条")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "BOE C20、Android、CN、zh、11*****-****-****-****-****C9、11*.1**.2**.**"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", { attrs: { rowspan: "2" } }, [_vm._v("使用信息")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "应用使用数据、使用等级、使用时间和频率、产品内玩过的游戏日志及结果、应用崩溃日志"
            ),
          ]),
          _vm._v(" "),
          _c("td", [_vm._v("改善产品的使用功能，提升产品的使用体验")]),
          _vm._v(" "),
          _c("td", [_vm._v("使用APP过程中APP收集")]),
          _vm._v(" "),
          _c("td", [_vm._v("收集1条")]),
          _vm._v(" "),
          _c("td", [_vm._v("累计使用天数 **天，累计获得成果数量** 个")]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("语音内容")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "通过收集使用者的语音内容，处理并完成产品内的跟读、发音测试。"
            ),
          ]),
          _vm._v(" "),
          _c("td", [_vm._v("用户使用中主动输入")]),
          _vm._v(" "),
          _c("td", [_vm._v("仅使用不收集，不存储。")]),
          _vm._v(" "),
          _c("td", [_vm._v("-")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }